import type { MessageKeys } from 'next-intl';
import type { DisplayModelVersion, FormTabType, ModelVersion } from '@/app/types';
import { getAvailableOptions } from './validate-settings';

/**
 * 统一格式化宽高比显示。
 * - 当为 'auto' 时返回多语言文案
 * - 当为空且任务类型支持 'intelligent' 时返回"智能"文案
 * - 其他情况直接返回原始值
 */
export function formatAspectRatio(
  aspectRatio: string | undefined,
  t: (
    key: MessageKeys<
      IntlMessages,
      | 'create.createForm.settings.aspectRatio.optionAuto.text'
      | 'create.createForm.settings.aspectRatio.optionIntelligent.tag'
    >,
  ) => string,
  options?: {
    taskType?: Exclude<FormTabType, 'scene'>;
    modelVersion?: DisplayModelVersion;
  },
): string {
  if (!aspectRatio) {
    // 如果 aspectRatio 为空，且任务类型支持 intelligent，则显示"智能"
    if (options?.taskType && options?.modelVersion) {
      const availableRatios =
        getAvailableOptions(options.modelVersion as ModelVersion, options.taskType).aspect_ratio || [];
      if (availableRatios.includes('intelligent')) {
        return t('create.createForm.settings.aspectRatio.optionIntelligent.tag');
      }
    }
    return '';
  }
  return aspectRatio === 'auto' ? t('create.createForm.settings.aspectRatio.optionAuto.text') : aspectRatio;
}
